/**
 * @author Daniel Aguirre
 * @file index.js
 * @description Patient Events Container
 */

// Dependencies
import React from 'react';
// import PropTypes from 'prop-types';

// Components
import AppRoutes from '@nephro/components/AppRoutes';
import AppCardLayout from '@nephro/components/AppCardLayout';

// Routes
import routes from './routes';

/**
 * PatientEvents Container.
 * @return { Node } React Patient Events container.
 */
const PatientEventsContainer = () => {
  return (
    <AppCardLayout>
      <AppRoutes routes={routes} />
    </AppCardLayout>
  );
};

/**
 * @name PatientEvents.propTypes
 * @type { Object }
 */
PatientEventsContainer.propTypes = {};

/**
 * Default props
 */
PatientEventsContainer.defaultProps = {};

export default PatientEventsContainer;
